import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as FeatherIcon from "react-feather";
import { createSuggestedCompetitorRequest } from "../../../store/features/actions/suggestedCompetitorActions";
import { fetchSuggestedCompetitorsRequest } from "../../../store/features/actions/fetchSuggestedCompetitorActions";
import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";
import Alert from "../../HtmlElements/Alert";
import { Modal } from "react-bootstrap";
import APP_CONFIG from "../../../config/appConfig";
import { submitCompetitorListRequest } from "../../../store/features/actions/competitorListActions";
// import "./Competitors.css";

const MARKET_IQ_SUBDIMENSIONS = [
  "Executive Summary Next Steps",
  "OpsSupply ScoreCard",
  "Innovation Theme Radar",
  "ProdInno ScoreCard",
  "Quantitative Snapshot",
  "MarketingDistributions ScoreCard",
  "Inbound Logistics",
  "OrgLeader ScoreCard",
  "Overall Competitive Threat Assessment",
  "Outbound Distribution",
  "FinancialsStrategy ScoreCard",
  "Cost Structure Analysis",
  "GTM & Distribution Strategy Analysis",
  "Warehousing & Channels",
  "Company Overview",
  "R&D Spend Estimates",
  "MarketPosition ScoreCard",
  "Raw Material Imports",
  "Global Operations Network",
];

export default function SuggestedCompetitors({
  totalCompetitorsGenerated,
  user,
  generatedCompetitors,
  reloadGeneratedCompetitors,
}) {
  const dispatch = useDispatch();
  const admin_roles = ["ROLE_MNM_SUBSCRIBER", "ROLE_ACCOUNT_MANAGER"];
  const selectedIndustry = admin_roles.includes(user?.growth_iq_role_name)
    ? localStorage.getItem("selectedIndustry")
    : user?.industry;
  // Dummy data – replace with API later
  // const [suggestedList, setSuggestedList] = useState([]);
  // const [suggestedList, setSuggestedList] = useState([
  //   { company: "BASF SE" },
  //   { company: "Dow Chemical" },
  //   { company: "Evonik Industries" },
  //   { company: "Solvay" },
  //   { company: "Clariant" },
  // ]);

  const { creating, success, error } = useSelector(
    (state) => state.suggestedCompetitorReducer
  );

  const {
    loading,
    data,
    error: fetchError,
  } = useSelector((state) => state.fetchSuggestedCompetitorsReducer);

  const generatedSet = new Set(
    (generatedCompetitors?.result || []).map((item) =>
      item?.company?.toLowerCase().trim()
    )
  );

  const ITEMS_PER_PAGE = 5;
  const [currentPage, setCurrentPage] = useState(1);

  // const totalItems = data?.data?.length || 0;
  // const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  // const paginatedList = data?.data?.slice(startIndex, endIndex);

  const filteredSuggested = data?.data?.filter(
    (item) => !generatedSet.has(item.name.toLowerCase().trim())
  );

  const totalItems = filteredSuggested?.length || 0;
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  const paginatedList = filteredSuggested?.slice(startIndex, endIndex);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingCompetitor, setPendingCompetitor] = useState([]);

  // const handleAddCompetitor = (competitorName) => {
  //   dispatch(
  //     createSuggestedCompetitorRequest({
  //       client: user?.company_name_for_growth_iq,
  //       competitor: competitorName,
  //     })
  //   );
  // };

  // const handleAddCompetitor = (competitorName) => {
  //   setPendingCompetitor(competitorName);
  //   setShowConfirmModal(true);
  // };

  const handleAddCompetitor = (item) => {
    setPendingCompetitor(item);
    setShowConfirmModal(true);
  };

  // const confirmAddCompetitor = () => {
  //   if (!pendingCompetitor) return;

  //   dispatch(
  //     createSuggestedCompetitorRequest({
  //       client: user?.company_name_for_growth_iq,
  //       competitor: pendingCompetitor,
  //     })
  //   );

  //   setShowConfirmModal(false);
  //   setPendingCompetitor(null);
  // };

  const confirmAddCompetitor = () => {
    if (!pendingCompetitor) return;

    dispatch(
      createSuggestedCompetitorRequest({
        user_id: user?.user_id,
        user_type: "MarketIQ",
        client: user?.company_name_for_growth_iq,
        competitor: pendingCompetitor?.name,
        company_id: pendingCompetitor?.snp_code,
        subdimensions: MARKET_IQ_SUBDIMENSIONS,
        ksCompanies: [pendingCompetitor?.code],
        industry: selectedIndustry,
      })
    );

    setShowConfirmModal(false);
    setPendingCompetitor(null);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [data, generatedCompetitors]);

  useEffect(() => {
    if (user?.company_name_for_growth_iq) {
      dispatch(
        fetchSuggestedCompetitorsRequest({
          client: user.company_name_for_growth_iq,
        })
      );
    }
  }, [dispatch, user?.company_name_for_growth_iq]);

  useEffect(() => {
    if (success) {
      reloadGeneratedCompetitors();
    }
  }, [success]);

  return (
    <>
      <div className="competitor-list mt-5">
        <div className="all_acccounts_block">
          <h5 className="all_acccounts_head m-2">
            <span style={{ paddingRight: "5px" }}>Suggested Competitors</span>
          </h5>
        </div>

        {success && (
          <Alert
            type="success"
            message="Competitor profile request added successfully!"
          />
        )}

        {loading && (
          <div className="m-2">
            <span>Loading suggested competitors...</span>
          </div>
        )}

        {fetchError && (
          <div className="m-2">
            <Alert type="danger" message={fetchError} />
          </div>
        )}

        <div
          className="table-responsive"
          style={{
            maxHeight: "350px",
            overflow: "scroll",
          }}
        >
          <table className="table custom-resizable-table">
            <thead>
              <tr
                className="custom-resizable-table-header"
                style={{
                  position: "sticky",
                  top: "0",
                  zIndex: "3",
                  backgroundColor: "#ffffff",
                }}
              >
                <th>Competitor</th>
                <th width="200px"></th>
              </tr>
            </thead>
            <tbody>
              {/* {data?.data &&
              data.data.map((item, index) => ( */}
              {paginatedList &&
                paginatedList.map((item, index) => (
                  <tr key={item.code || index} className="gtr-row">
                    <td className="gtr-cell">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          width="50"
                          src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                            item.name
                          )}`}
                          alt="logo"
                          className="all_account_icon_img mr-1"
                        />
                        <span className="first_comp">{item.name}</span>
                      </div>
                    </td>

                    <td className="gtr-cell">
                      <button
                        className="add_account_companies"
                        // disabled={creating}
                        disabled={
                          creating ||
                          totalCompetitorsGenerated ==
                            user?.no_of_comp_iq_access_limit
                        }
                        title={
                          totalCompetitorsGenerated <
                          user?.no_of_comp_iq_access_limit
                            ? "Add competitor"
                            : "Competitor addition limit reached"
                        }
                        onClick={() => handleAddCompetitor(item)}
                        style={{
                          padding: "5px 10px",
                          backgroundColor: "rgb(35, 36, 40)",
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#fff",
                          border: "none",
                          borderRadius: "6px",
                          ...(totalCompetitorsGenerated ==
                            user?.no_of_comp_iq_access_limit && {
                            backgroundColor: "#ccc",
                          }),
                        }}
                      >
                        <FeatherIcon.Plus size={12} className="mr-1" />
                        Add Competitor
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          {totalPages > 1 && (
            <div
              className="d-flex justify-content-between align-items-center mt-2"
              style={{ fontSize: "13px" }}
            >
              <span>
                Showing {startIndex + 1}–{Math.min(endIndex, totalItems)} of{" "}
                {totalItems}
              </span>

              <div>
                <button
                  className="btn btn-sm btn-light mr-1"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                >
                  Previous
                </button>

                <button
                  className="btn btn-sm btn-light"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => p + 1)}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        show={showConfirmModal}
        onHide={() => {
          setShowConfirmModal(false);
          setPendingCompetitor(null);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Add Competitor</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            Are you sure you want to add{" "}
            <strong>{pendingCompetitor?.name}</strong> as a competitor?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="profile-card-button "
            onClick={() => {
              setShowConfirmModal(false);
              setPendingCompetitor(null);
            }}
          >
            Cancel
          </button>

          <button
            className="profile-card-button profile-card-button-primary"
            onClick={confirmAddCompetitor}
            disabled={creating}
          >
            {creating ? "Adding..." : "Confirm"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
